// removed by extract-text-webpack-plugin
module.exports = {"logo":"styles__logo__20aoM","header":"styles__header__1BRAi","responsiveNavWidth":"styles__responsiveNavWidth__2cQML","scrolling":"styles__scrolling__2r9Kc","byDC":"styles__byDC__2SSrN","brand":"styles__brand__29dRU","designForCue":"styles__designForCue__19ONG","button":"styles__button__2JkAP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupNavigation/styles.scss
// module id = 418
// module chunks = 0